import script from "./EnvRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvRibbon.vue?vue&type=script&setup=true&lang=js"

import "./EnvRibbon.vue?vue&type=style&index=0&id=8731f5e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8731f5e8"]])

export default __exports__